import React from 'react';

const AuraLogo = ({
  showText = true,
  size = 'default',
  className = '',
  onClick,
}) => {
  const sizeMap = {
    small: { sphere: 32, title: 'text-lg', sub: 'text-label' },
    default: { sphere: 40, title: 'text-h2', sub: 'text-label' },
    large: { sphere: 56, title: 'text-h1', sub: 'text-body' },
    xl: { sphere: 72, title: 'text-display', sub: 'text-body' },
  };

  const dimensions = sizeMap[size] || sizeMap.default;

  return (
    <div
      className={`flex items-center gap-3 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') onClick(e);
            }
          : undefined
      }
    >
      <svg
        width={dimensions.sphere}
        height={dimensions.sphere}
        viewBox="0 0 100 100"
        aria-hidden
      >
        <circle cx="50" cy="50" r="44" fill="#234A3C" />
        <circle cx="50" cy="50" r="32" fill="none" stroke="#A98B54" strokeWidth="1" />
        <circle cx="50" cy="50" r="8" fill="#F3EFE6" />
      </svg>

      {showText && (
        <div className="flex flex-col leading-tight">
          <span className={`font-display ${dimensions.title} text-ink`}>Aura</span>
          <span className={`font-sans ${dimensions.sub} text-ink-muted`}>Finance</span>
        </div>
      )}
    </div>
  );
};

export default AuraLogo;
